import { useContext } from 'react';
import Compare from '../Compare';
import Stack from '../../../shared/layouts/Stack';
import CategoryHeader from '../CategoryHeader';
import { CompareContext } from '../ComparePage';
import { findTranslation } from '../../../../utils/helpers';
import { getPropertyTypeOptions } from '../../house/HomeSection';
import {useTranslation} from "react-i18next";

const SECTION = 'residence_home';

const CompareHomeSection = () => {
  const {
    showOnlyDiff,
    hasDiff,
    shouldShow,
    ownHouseData,
    otherHouseData,
    handleHouseDataChange,
    homeFields,
    hasSectionCopiedFields,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const handleDataChange = (e) => handleHouseDataChange(e, SECTION);

  if (
    showOnlyDiff &&
    !hasSectionCopiedFields(SECTION) &&
    !hasDiff(homeFields, ownHouseData, otherHouseData)
  )
    return null;

  return (
    <Stack space="l">
      <CategoryHeader>
        <span>{t('Woninggegevens')}</span>
        <span>{t('Woninggegevens')}</span>
      </CategoryHeader>
      <Stack space="m">
        {shouldShow('type', ownHouseData, otherHouseData, SECTION) && (
          <Compare
            label={t("Type woning")}
            name="type"
            section={SECTION}
            leftValue={ownHouseData?.type}
            rightValue={otherHouseData?.type}
            valueTransformer={(value) =>
              findTranslation(value, getPropertyTypeOptions())
            }
            onUpdate={handleDataChange}
          />
        )}
        {shouldShow(
          'taxation_value_amount',
          ownHouseData,
          otherHouseData,
          SECTION
        ) && (
          <Compare
            label={t("Taxatiewaarde")}
            name="taxation_value_amount"
            section={SECTION}
            leftValue={ownHouseData?.taxation_value_amount}
            rightValue={otherHouseData?.taxation_value_amount}
            onUpdate={handleDataChange}
            isCurrency
          />
        )}
        {shouldShow(
          'taxation_value_date',
          ownHouseData,
          otherHouseData,
          SECTION
        ) && (
          <Compare
            label={t("Taxatiedatum")}
            name="taxation_value_date"
            section={SECTION}
            leftValue={ownHouseData?.taxation_value_date}
            rightValue={otherHouseData?.taxation_value_date}
            valueTransformer={(value) =>
              value ? value.split('-') : ['', '', '']
            }
            onUpdate={handleDataChange}
          />
        )}
        {shouldShow(
          'woz_value_amount',
          ownHouseData,
          otherHouseData,
          SECTION
        ) && (
          <Compare
            label={t("WOZ-waarde")}
            name="woz_value_amount"
            section={SECTION}
            leftValue={ownHouseData?.woz_value_amount}
            rightValue={otherHouseData?.woz_value_amount}
            onUpdate={handleDataChange}
            isCurrency
          />
        )}
        {shouldShow(
          'woz_value_date',
          ownHouseData,
          otherHouseData,
          SECTION
        ) && (
          <Compare
            label={t("WOZ-jaar")}
            name="woz_value_date"
            section={SECTION}
            leftValue={ownHouseData?.woz_value_date}
            rightValue={otherHouseData?.woz_value_date}
            onUpdate={handleDataChange}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default CompareHomeSection;
